// this model is only used for the agent profile that gets added/removed from the local/session vairables
export class AgentProfile {
    public email: string;
    public user_id: string; // tslint:disable-line
    public name: string;
    public nickname: string;
    public canInvoice: boolean;
    public agentCode: string;
    public agencyCode: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agent-profile.model.ts